import { defineStore } from 'pinia';

import * as state from './accounting.state';
import * as getters from './accounting.getters';
import * as actions from './accounting.actions';

export const useAccountingStore = defineStore('accounting', () => ({
  ...state,
  ...getters,
  ...actions
}));
